import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import GraphQL from '../../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  findSchool,
  updateSchoolData,
  updateSchoolLogo,
} from '../../../shared/queries/SchoolData';
import SchoolDataForm from './Form';
import {
  generateReport,
  openReport,
  resizeImage,
  upLoadFile,
} from '../../../shared/utils/smartutils';
import {
  REPORT_PARAMETERS,
  REPORT_TYPES,
} from '../../../shared/utils/constants';

const FormHandler = (props) => {
  const { t, dispatch } = props;
  const [school, setSchool] = useState();

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadSchoolData = () => {
    showLoading();
    const query = findSchool();
    GraphQL(query, {})
      .then((res) => {
        setSchool({ ...res.findSchool });
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const handleSubmit = async (values) => {
    showLoading();
    const mutationQuery = updateSchoolData(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        loadSchoolData();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const getReportPreview = () => {
    showLoading();
    const formData = new FormData();
    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.DEMO);
    generateReport(formData)
      .then(async (res) => {
        await openReport(res.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const handleSaveLogo = async (values) => {
    showLoading();
    const { file } = values;
    let fileUrl = null;
    if (file) {
      const resized = await resizeImage(file);
      const uploadedFile = await upLoadFile(resized);
      fileUrl = uploadedFile.fileId;
    }
    const mutation = updateSchoolLogo(values, fileUrl);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        loadSchoolData();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    loadSchoolData();
  }, []);

  return (
    <SchoolDataForm
      onSubmit={handleSubmit}
      showLoading={showLoading}
      hideLoading={hideLoading}
      school={school}
      handleSaveLogo={handleSaveLogo}
      getReportPreview={getReportPreview}
    />
  );
};

FormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(FormHandler)
);
